
import { formatDateTime } from "@/components/mixins";
import { LoadingSpinner } from "@/components/Elements/LoadingSpinner.vue";
import _ from "lodash";

export default {
  name: "CustomTable",
  components: {
    LoadingSpinner,
  },
  props: {
    items: { type: Array, default: () => [] },
    fields: { type: Array, required: true },
    sortBy: { type: String, default: "" },
    sortDescProp: { type: Boolean, default: false },
    filter: { type: String, default: "" },
    filterFunction: { type: Function, default: null },
    currentPage: { type: Number, default: 1 },
    perPage: { type: Number, default: null },
    showEmpty: { type: Boolean, default: true },
    emptyText: { type: String, default: "No data found" },
    busy: { type: Boolean, default: false },
    showPagination: { type: Boolean, default: false },
    usePagination: { type: Boolean, default: true },
    totalRows: { type: Number, default: 0 },
  },
  mixins: [formatDateTime],
  data() {
    return {
      sortKey: this.sortBy,
      sortDesc: this.sortDescProp,
      currentPageInternal: this.currentPage || 1,
    };
  },
  computed: {
    filteredItems() {
      let data = this.items;
      if (this.filter && this.filterFunction) {
        data = data.filter(this.filterFunction);
      } else if (this.filter) {
        data = data.filter((item) =>
          Object.values(item).some((val) => String(val).toLowerCase().includes(this.filter.toLowerCase()))
        );
      }
      if (this.sortKey) {
        data = [...data].sort((a, b) => {
          if (a[this.sortKey] < b[this.sortKey]) return this.sortDesc ? 1 : -1;
          if (a[this.sortKey] > b[this.sortKey]) return this.sortDesc ? -1 : 1;
          return 0;
        });
      }
      return data;
    },
    pagedItems() {
      if (!this.usePagination || this.perPage === null) {
        return this.filteredItems;
      } else {
        const start = (this.currentPageInternal - 1) * this.perPage;
        return this.filteredItems.slice(start, start + this.perPage);
      }
    },
    totalPages() {
      if (this.perPage === null) {
        return 1;
      } else {
        const total = this.totalRows > 0 ? this.totalRows : this.filteredItems.length;
        return Math.ceil(total / this.perPage) || 1;
      }
    },
  },
  methods: {
    sort(key) {
      if (this.sortKey === key) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortKey = key;
        this.sortDesc = false;
      }
      this.$emit("sort-changed", { sortBy: this.sortKey, sortDesc: this.sortDesc });
    },
    getValueByPath(obj, path) {
      return _.get(obj, path);
    },
  },
  watch: {
    sortBy(val) {
      this.sortKey = val;
    },
    sortDescProp(val) {
      this.sortDesc = val;
    },
    currentPage(val) {
      if (val && val > 0) {
        this.currentPageInternal = val;
      }
    },
    currentPageInternal(val) {
      this.$emit("update:currentPage", val);
    },
    filteredItems(val) {
      // Reset to page 1 if current page would be invalid
      if (this.currentPageInternal > this.totalPages) {
        this.currentPageInternal = 1;
      }
      this.$emit("filtered", val);
    },
  },
}